const VIEW_TYPE_CHANGE = 'VIEW_TYPE_CHANGE';
const DATE_CONTEXT_CHANGE = 'DATE_CONTEXT_CHANGE';
const START_DATE_CHANGE = 'START_DATE_CHANGE';
const END_DATE_CHANGE = 'END_DATE_CHANGE';
const ACCOUNT_VIEW = 'ACCOUNT_VIEW';
const RESET_STATE = 'RESET_STATE';

export {VIEW_TYPE_CHANGE, DATE_CONTEXT_CHANGE, START_DATE_CHANGE, END_DATE_CHANGE, ACCOUNT_VIEW, RESET_STATE};
